import {} from 'framework7-react';
import { FC } from 'react';
import { RegisterPhone } from './RegisterPhone/RegisterPhone';

export const RegisterPhonePage: FC = () => {
  return <RegisterPhone />;
};
